import type { ErrorSeverity, ErrorCategory } from '@/types';

export const SEVERITY_CONFIG: Record<ErrorSeverity, { color: string; bgColor: string; label: string }> = {
  debug: { color: 'text-text-muted', bgColor: 'bg-surface-light', label: 'Debug' },
  info: { color: 'text-info', bgColor: 'bg-info/10', label: 'Info' },
  warning: { color: 'text-warning', bgColor: 'bg-warning/10', label: 'Warning' },
  error: { color: 'text-error', bgColor: 'bg-error/10', label: 'Error' },
  critical: { color: 'text-error', bgColor: 'bg-error/20', label: 'Critical' },
};

export const CATEGORY_CONFIG: Record<ErrorCategory, { label: string }> = {
  task_execution: { label: 'Task Execution' },
  database: { label: 'Database' },
  api: { label: 'API' },
  authentication: { label: 'Authentication' },
  external_service: { label: 'External Service' },
  ai_model: { label: 'AI Model' },
  email: { label: 'Email' },
  file_processing: { label: 'File Processing' },
  webhook: { label: 'Webhook' },
  system: { label: 'System' },
};

export const TIME_RANGES = [
  { value: 1, label: 'Last hour' },
  { value: 6, label: 'Last 6 hours' },
  { value: 24, label: 'Last 24 hours' },
  { value: 72, label: 'Last 3 days' },
  { value: 168, label: 'Last 7 days' },
];

export type AdminTab = 'cost-api' | 'operations' | 'errors' | 'users' | 'system' | 'twitter';

export const ADMIN_TABS: { id: AdminTab; label: string }[] = [
  { id: 'cost-api', label: 'Cost & API' },
  { id: 'operations', label: 'Operations' },
  { id: 'errors', label: 'Errors' },
  { id: 'users', label: 'Users' },
  { id: 'system', label: 'System' },
  { id: 'twitter', label: 'Twitter' },
];

// Chart colors for dark theme
export const CHART_COLORS = {
  primary: '#D4A574',
  primaryLight: 'rgba(212, 165, 116, 0.15)',
  success: '#22c55e',
  error: '#ef4444',
  info: '#3b82f6',
  warning: '#f59e0b',
  text: '#71717a',
  grid: '#333333',
};
